import * as React from 'react';
import { Company } from '../company';

export const themeStyle = (name: string, theme: any) => {
  let value = '#171717';
  if (theme) {
    value = theme[name];
  }

  return { color: value };
};

export interface CompanyAppPreview {
  company: Company;
}

export const CompanyAppPreview = ({ company }: CompanyAppPreview) => (
  <div className={'previewWrapper'}>
    <div
      className={'previewWindow'}
      style={themeStyle('background', company.theme)}
    >
      <div className={'previewCover'} key={JSON.stringify(company)}>
        <div
          className={'previewCoverOverlay'}
          style={themeStyle('background', company.theme)}
        />
        <img
          className={'previewCoverImage'}
          src={company.image_identifier}
          alt={company.name}
        />
      </div>

      <h1
        className={'ph3 f4 b previewTitle'}
        style={themeStyle('key', company.theme)}
      >
        {company.name}
      </h1>
      {company.public_url && (
        <p
          className={'pill ba dib pa1 ph3 br-pill ttu b f6 ma0 mh3'}
          style={themeStyle('key', company.theme)}
        >
          WEBSITE
        </p>
      )}
      <p
        className={'previewDescription'}
        style={themeStyle('body', company.theme)}
      >
        {company.description_text}
      </p>
    </div>
  </div>
);

export default CompanyAppPreview;
